<template lang="pug">
  .container-listagem

    el-row
      el-col
        Pesquisa(
          placeHolder = "Informe o nome da Gleba ou nº do Processo",
          @search="handlePesquisa"
          @resetSearch="resetPesquisa"
          :cardStyle="{margin:'20px', 'border-radius':'10px'}"
        )

    app-listagem(
      :has-refresh-button="true",
      :showButtonOrdemServico="false",
      :has-expansivel="false",
      :json-headers="colunas",
      :json-data="processosArrecadacao",
      :totalElements="totalCadastros",
      :pagina="pagina",
      @updateListagem="resetPesquisa",
      @changePage="changePage",
      @sort="sortChanged",
      @selected="false",
      @executar="executar"
    )

</template>

<script>
import { mapActions } from 'vuex'
import ButtonAcoes from '@/components/ButtonAcoes'
import AppPaginacao from '@/components/AppPaginacao'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import Pesquisa from '@/components/Pesquisa'
import CONFIGS from '@/constants/configs'
import Utils from '@/utils/utils'
import cloneDeep from 'lodash/cloneDeep'
import AppListagem from '@/components/AppListagem'
import BaseFiltroArrecadacao from '../../mixins/BaseFiltroArrecadacao'
import statusProcesso from '@/constants/statusProcessoArrecadacao'

const FILTRO_EMPTY = {
  pagina: 0,
  tamanhoPagina: CONFIGS.TAMANHO_PAGINACAO
}

export default {
  components: {
    ButtonAcoes,
    AppPaginacao,
    AppDividerRefreshButton,
    Pesquisa,
    AppListagem
  },

  data () {
    return {
      colunas: [
        {
          propriedade: 'numeroProcesso',
          id: 0,
          titulo: 'Processo',
          formatter: Utils.formatEmptyRow,
          acoes: []
        },
        {
          propriedade: 'cadastroColetivo.pecaTecnica.gleba',
          id: 1,
          titulo: 'Gleba',
          formatter: Utils.formatEmptyRow,
          acoes: []
        },
        {
          propriedade: 'dataChegadaSetor',
          id: 2,
          titulo: 'Data',
          formatter: Utils.formatEmptyRow,
          acoes: []
        },
        {
          propriedade: 'cadastroColetivo.pecaTecnica.municipios',
          id: 3,
          titulo: 'Município',
          formatter: this.formatMunicipio,
          acoes: []
        },
        {
          propriedade: 'statusName',
          id: 4,
          titulo: 'Situação',
          formatter: Utils.formatEmptyRow,
          acoes: []
        },
        {
          id: 5,
          titulo: 'Ações',
          propriedade: 'tipo',
          ordem: 6,
          acoes: [
            {
              id: 1,
              nome: 'Publicar portaria',
              icone: 'fa-file',
              codigo: 'INFORMAR_ENVIO',
              ordem: 1,
              show: this.informarEnvio
            },
            {
              id: 2,
              nome: 'Acusar Publicação',
              icone: 'fa-file',
              codigo: 'CONFIRMAR_PUBLICACAO',
              ordem: 2,
              show: this.confirmarPublicacao
            },
            {
              id: 3,
              nome: 'Emitir minuta de Matricula',
              icone: 'fa-file',
              codigo: 'MINUTA_MATRICULA',
              ordem: 3,
              show: this.minutaMatricula
            }
          ]
        }
      ],
      filtro: cloneDeep(FILTRO_EMPTY),
      Utils,
      portariaPdfBytes: null,
      showModalVisualizarPortaria: false,
      showModalAssinatura: false,
      idsProcessosAssinatura: [],
      processosSelecionados: []
    }
  },

  mixins: [BaseFiltroArrecadacao, AppNotificacao],

  created () {
    this.setMainCardVisibility(false)
    this.init()
  },

  methods: {
    INFORMAR_ENVIO (_this, { item }) {
      this.$router.push({
        name: 'gp/informarEnvio',
        query: {
          idProcesso: item.id,
          idPortaria: item.portaria.id
        }
      })
    },

    CONFIRMAR_PUBLICACAO (_this, { item }) {
      this.$router.push({
        name: 'gp/confirmarEnvio',
        query: {
          idProcesso: item.id,
          idPortaria: item.portaria.id
        }
      })
    },

    MINUTA_MATRICULA (_this, { item }) {
      this.$router.push({
        name: 'oficiomatricula/informarDados',
        query: {
          idProcesso: item.id,
          idOficio: item.matricula.id
        }
      })
    },

    informarEnvio (processo) {
      return processo.status === statusProcesso.AGUARDANDO_ENVIO_DIARIO_OFICIAL
    },

    confirmarPublicacao (processo) {
      return (
        processo.status === statusProcesso.AGUARDANDO_PUBLICACAO_DIARIO_OFICIAL
      )
    },

    minutaMatricula (processo) {
      return (
        processo.status === statusProcesso.AGUARDANDO_MINUTA_MATRICULA
      )
    },

    ...mapActions({
      setMainCardVisibility: 'userInterface/setMainCardVisibility',
      emitirPortaria: 'portariaArrecadacao/emitirPortaria',
      assinar: 'processoArrecadacao/tramitarComAssinatura'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gp/components/GpListagem.vue